import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import "../base/pd-base-ui-input.js";
import { PdBaseInputElement } from "../base/pd-base-input-element.js";
import { css, html, nothing } from "lit";
import { property } from "lit/decorators.js";
import "@progressive-development/pd-icon/pd-icon";
import { classMap } from "lit/directives/class-map.js";
//#region src/pd-input-time/PdInputTime.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Time input component for selecting hours and minutes.
*
* @tagname pd-input-time
* @summary Time picker input with native browser support.
*
* @event input-icon-click - Fired when the input icon is clicked.
* @event validate-form - Fired when time value changes for validation.
* @event field-change - Fired when time value changes.
*
* @cssprop --pd-input-field-width - Input width. Default: `250px`.
* @cssprop --pd-input-field-height - Input height. Default: `2.2rem`.
* @cssprop --pd-input-field-bg-col - Background color. Default: `var(--pd-default-bg-col)`.
* @cssprop --pd-input-field-border - Border style. Default: `1px solid var(--pd-default-light-col)`.
* @cssprop --pd-input-field-border-bottom - Bottom border. Default: `2px solid var(--pd-default-col)`.
* @cssprop --pd-input-icon-size - Icon size. Default: `calc(var(--pd-input-field-height) * 0.9)`.
* @cssprop --pd-input-icon-color - Icon color. Default: `var(--pd-default-col)`.
*/
var PdInputTime = class extends PdBaseInputElement {
	static get styles() {
		return [PdBaseInputElement.styles, css`
        * {
          box-sizing: border-box;
        }
      `];
	}
	constructor() {
		super();
		this.clickableIcon = false;
		this.iconLabel = "";
		this._inputType = 9;
	}
	render() {
		const inputId = `${this.id}Input`;
		const errorId = `${this.id}Error`;
		return html`
      ${this._renderLabel(inputId)}
      <div
        class="${classMap(this.getClassmap({ input: true }))}"
      >
        <!-- Feld vor Icon: Das In-Feld-Icon ist absolut positioniert, die
             DOM-Reihenfolge hat also keinen visuellen Effekt — wohl aber
             auf die Tab-Reihenfolge. Stünde das Icon zuerst, landete man
             beim Tabben darauf, bevor man im Eingabefeld ist. -->
        <input
          id="${inputId}"
          name="${this.name || this.valueName || this.autoCompleteName}"
          class="input-style ${this.gradient ? "gradient" : ""}"
          type="time"
          .value="${this._value}"
          ?readonly="${this.readonly}"
          ?disabled="${this.disabled}"
          aria-invalid="${this._invalid}"
          aria-describedby="${this._errorMsg ? errorId : ""}"
          @keyup="${this._onKeyUp}"
          @change="${this._onChange}"
          @blur="${this._onBlur}"
          @focus="${this._onFocus}"
        />
        ${this.icon ? html`
                <pd-icon
                  icon="${this.icon}"
                  ?activeIcon="${this.clickableIcon}"
                  class="infield-icon"
                  tabindex="${this.clickableIcon ? 0 : -1}"
                  role="${this.clickableIcon ? "button" : "img"}"
                  aria-label="${this.clickableIcon ? this.iconLabel : ""}"
                  aria-hidden="${!this.clickableIcon}"
                  @click="${this.clickableIcon ? this._iconClicked : null}"
                  @keydown="${this.clickableIcon ? this._onIconKeyDown : null}"
                ></pd-icon>
              ` : nothing}
      </div>
      ${this._renderErrorMsg(errorId)}
    `;
	}
	_onChange(e) {
		this._handleChangedValue(this._input.value, e, true);
	}
	_iconClicked() {
		this.dispatchEvent(new CustomEvent("input-icon-click", {
			bubbles: true,
			composed: true
		}));
	}
	_onIconKeyDown(event) {
		if (event.key === " " || event.key === "Enter") {
			event.preventDefault();
			this._iconClicked();
		}
	}
};
__decorate([property({ type: String })], PdInputTime.prototype, "icon", void 0);
__decorate([property({ type: Boolean })], PdInputTime.prototype, "clickableIcon", void 0);
__decorate([property({ type: String })], PdInputTime.prototype, "iconLabel", void 0);
//#endregion
export { PdInputTime };
